/**
 * 🚪 Door-Opener Configuration Component
 * Warm-Up System: Sendet Opener-Mail vor Main-Mail
 */

import React, { useState, useEffect } from 'react';
import { Mail, CheckCircle } from 'lucide-react';
import toast from 'react-hot-toast';

const DoorOpenerConfig = ({ segment, onUpdate }) => {
  const defaultDoorOpenerText = 'Sehr geehrte Damen und Herren,\n\nbitte beachten Sie die nachstehende Nachricht.\n\nMit freundlichen Grüßen';
  const [enabled, setEnabled] = useState(false);
  const [doorOpenerText, setDoorOpenerText] = useState(defaultDoorOpenerText);
  
  const isEnabled = segment.config?.door_opener?.enabled || false;
  
  useEffect(() => {
    const config = segment.config?.door_opener || {};
    if (config.enabled) {
      setEnabled(true);
      setDoorOpenerText(config.text || defaultDoorOpenerText);
    }
  }, [segment, defaultDoorOpenerText]);
  
  const handleSave = () => {
    if (!doorOpenerText || doorOpenerText.trim().length < 10) {
      toast.error('Door-Opener-Text muss mindestens 10 Zeichen haben');
      return;
    }
    
    const updated = { ...segment };
    if (!updated.config) updated.config = {};
    updated.config.door_opener = {
      enabled: true,
      text: doorOpenerText
    };
    
    console.log('🚪 Door-Opener Config wird gespeichert:', updated.config.door_opener);
    onUpdate(updated);
    toast.success('Door-Opener konfiguriert');
  };
  
  const handleDisable = () => {
    const updated = { ...segment };
    if (!updated.config) updated.config = {};
    updated.config.door_opener = { enabled: false };
    
    onUpdate(updated);
    setEnabled(false);
    toast.success('Door-Opener deaktiviert');
  };
  
  return (
    <div className="bg-gradient-to-r from-green-50 to-emerald-50 dark:from-green-900/20 dark:to-emerald-900/20 p-4 rounded-lg border border-green-200 dark:border-green-700">
      <div className="flex items-center justify-between mb-3">
        <h4 className="text-sm font-semibold text-gray-900 dark:text-gray-100 flex items-center">
          <Mail className="h-4 w-4 mr-2 text-green-600" />
          🚪 Door-Opener (Warm-Up System)
        </h4>
        
        {!isEnabled ? (
          <button
            onClick={() => setEnabled(true)}
            className="px-3 py-1 bg-green-600 text-white rounded text-xs hover:bg-green-700"
          >
            Aktivieren
          </button>
        ) : (
          <button
            onClick={handleDisable}
            className="px-3 py-1 bg-gray-400 text-white rounded text-xs hover:bg-gray-500"
          >
            Deaktivieren
          </button>
        )}
      </div>
      
      {enabled && (
        <div className="space-y-3">
          <div className="bg-blue-50 dark:bg-blue-900/20 p-3 rounded text-xs text-blue-800 dark:text-blue-200 mb-3">
            <div className="font-semibold mb-1">ℹ️ Wie Door-Opener funktioniert:</div>
            <ul className="space-y-1 text-xs">
              <li>• <strong>Slot 0a:</strong> ALLE Segment-Empfänger bekommen Door-Opener (Klartext)</li>
              <li>• <strong>Slots 1-N:</strong> Main-Mails wie gewohnt</li>
              <li>• <strong>Gleicher SMTP:</strong> Beide vom selben Absender</li>
              <li>• <strong>Gleicher Subject:</strong> Door + Main haben gleichen Betreff</li>
              <li>• <strong>AI-Randomisierung:</strong> Door-Opener wird auch AI-variiert</li>
            </ul>
          </div>
          
          <div>
            <label className="block text-xs font-medium text-gray-700 dark:text-gray-200 mb-1">
              Door-Opener Text (Klartext):
            </label>
            <textarea
              value={doorOpenerText}
              onChange={(e) => setDoorOpenerText(e.target.value)}
              rows={6}
              className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded text-sm bg-white dark:bg-gray-800 font-mono"
              placeholder="Sehr geehrte Damen und Herren,&#10;&#10;bitte beachten Sie die nachstehende Nachricht.&#10;&#10;Mit freundlichen Grüßen"
            />
            <div className="text-xs text-gray-500 mt-1">
              Wird AI-randomisiert für jedes Segment. Subject & From-Name werden von der Main-Mail übernommen.
            </div>
          </div>
          
          <button
            onClick={handleSave}
            className="w-full px-4 py-2 bg-green-600 text-white rounded-md hover:bg-green-700 flex items-center justify-center space-x-2"
          >
            <CheckCircle className="h-4 w-4" />
            <span>Door-Opener speichern</span>
          </button>
        </div>
      )}
      
      {isEnabled && segment.config?.door_opener?.text && (
        <div className="mt-3 p-2 bg-green-50 dark:bg-green-900/20 rounded text-xs text-green-800 dark:text-green-200">
          ✅ Door-Opener aktiv: {segment.config.door_opener.text.substring(0, 50)}...
        </div>
      )}
    </div>
  );
};

export default DoorOpenerConfig;

